'use strict';
function recallParserService() {

    function trimQuotes(str) {
        var
            rexp_quotes_trim = new RegExp('^"{0,2}(.+?)"{0,2}$'),
            result = rexp_quotes_trim.exec(str);

        return result ? result[1] : str;
    }

    function getDescription(str, end_word) {
        var rexp_desc_keyval = new RegExp('^"?([A-Z]{3,})"?: (.+)\\.\\w', 'i');
        var f_key_index = str.indexOf(end_word);
        var t_str = str.substring(0, f_key_index - 1);

        if (rexp_desc_keyval.test(t_str)) {
            var match = rexp_desc_keyval.exec(t_str);
            return trimQuotes(match[2]);
        } else {
            return t_str;
        }
    }

    this.parse = function (str) {
        var
            rexp_keyval = new RegExp('([A-Z]{3,}) : ([^.\n]+)', 'g'),
            kv_list = [],
            rexp_result, t_desc, f_key;

        // search all KEY : "val"
        while (rexp_result = rexp_keyval.exec(str)) {
            t_desc = trimQuotes(rexp_result[2]);

            kv_list.push({
                title: rexp_result[1],
                description: t_desc
            });
        }

        // if finded parse description
        if (kv_list.length) {
            f_key = kv_list[0].title;
            t_desc = getDescription(str, f_key);

            return {
                description: t_desc,
                comments: kv_list,
            }
        } else {
            return str;
        }
    };
};

recallParserService.$inject = [];

module.exports = recallParserService;